export default "__VITE_ASSET__4ba830ea__"